import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Table from '@mui/material/Table';

import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import SearchIcon from '@mui/icons-material/Search';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import ReactHTMLTableToExcel from 'react-html-table-to-excel';
const headCells = [
  
 
   { id: 'or_createdate', numeric: false, label: 'Date' },
  { id: 'or_name', numeric: false, label: 'Name' },
  { id: 'or_email', numeric: false, label: 'Email' },
    { id: 'or_classtype', numeric: false, label: 'Preference - Duration' },


	   { id: '',  label: 'Scheduled' },
	   { id: 'trialclass', numeric: false, label: 'Status' },
	 { id: 'bm_name', numeric: false, label: 'Branch' },

   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width:'100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth:750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top:20,
    width: 1,
  },  
});
 export default class OrderTrail extends Component {

   constructor(props) {
      super(props);
	   var strdob=new Date();
	 var month="";
	const today = dayjs(); // today's date
const startOfMonth = dayjs().startOf('month'); 

	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
            this.state = {
				brachData:[],exporttrial:[],bmid:'',bm_name:'',bm_id:'',
				subid:'',subscribeData:[],sb_id:'',sb_title:'',or_startdate:'',startdate:'',sm_slotname:'',orderdata:[],page: 0,subid:'', bmid:'',prevpage:0,totaldata:0,rowsPerPage:20,subscribeData:[],rowsPaging:[], order:'desc' ,orderBy:'',names:'', redirect:false,pagename:'', booktype:'',
				//invoicedate:dayjs(Date.now()),invoicedate1:'',
				orderno:'',orname:'',oractive:'',classtype:'',invoicedate: startOfMonth, // from date
  invoicedate1: startOfMonth.format('YYYY-MM-DD'),

  invoicetodate: today, // to date
  invoicetodate1: today.format('YYYY-MM-DD'),
				//invoicedate:dayjs(Date.now()),invoicedate1:'',invoicetodate1:'',invoicetodate:dayjs(Date.now())
				}
   }
      
   
   myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val}); 
} 
	  


	componentWillMount  () {
	

	
	document.title = "AthaYog Living -  Trail Classes";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
	
	  this.OnloadGetBrachbind();
	 
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apiOrdercall(this.state.page,this.state.rowsPerPage);
 this.apiExportOrdercall();
} 		
 	  
/*handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 
	 todate1.setDate(date1.getDate() + 1);
	
     this.setState({ invoicedate:dayjs(date),
invoicedate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
invoicetodate: todate1,
invoicetodate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
	
	
  }
  handtodateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ invoicetodate:dayjs(date),
invoicetodate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }*/
  handdateChanges = (date) => {
  const startDate = dayjs(date);
  this.setState({
    invoicedate: startDate,
    invoicedate1: startDate.format('YYYY-MM-DD'),
  });
}

handtodateChanges = (date) => {
  const endDate = dayjs(date);
  this.setState({
    invoicetodate: endDate,
    invoicetodate1: endDate.format('YYYY-MM-DD'),
  });
}

  
  
   
apiOrdercall(page,rowsPerPage){
	 
	let strbranch=this.state.bmid;
	 if(localStorage.getItem("AYLrole")!=="1")
	 {
		 strbranch=localStorage.getItem("AYLbrid");
	 } 
	axios.get(Serverurl+'ajaxorders.php?action=list&StartIndex='+page+'&PageSize='+rowsPerPage+'&or_name='+this.state.orname+'&or_enddate='+this.state.oractive+'&or_bm_id='+strbranch+'&or_invoicedate='+this.state.invoicedate1+'&or_invoicetodate='+this.state.invoicetodate1+'&or_booktype=2&or_classtype='+this.state.classtype)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  orderdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count)
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({orderdata:[],totaldata:0});
	 }

    });
}
  
apiExportOrdercall(page,rowsPerPage){
	 
	let strbranch=this.state.bmid;
	 if(localStorage.getItem("AYLrole")!=="1")
	 {
		 strbranch=localStorage.getItem("AYLbrid");
	 } 
	axios.get(Serverurl+'ajaxorders.php?action=list&or_name='+this.state.orname+'&or_enddate='+this.state.oractive+'&or_bm_id='+strbranch+'&or_invoicedate='+this.state.invoicedate1+'&or_invoicetodate='+this.state.invoicetodate1+'&or_booktype=2&or_classtype='+this.state.classtype)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  exporttrial: resp.data,  
			   totaldata:parseInt(resp.data[0].count)
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({exporttrial:[],totaldata:0});
	 }

    });
}
	 
handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apiOrdercall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  handleClickSearch=()=>{  
  
  this.apiOrdercall(this.state.page,this.state.rowsPerPage);
 this.apiExportOrdercall();
  } 
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apiOrdercall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};	  
	  
handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ invoicedate:dayjs(date),
invoicedate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  OnloadGetBrachbind(){
  axios.post(Serverurl+'ajaxbranch.php?action=getall&sorting=bm_id')
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						brachData:resp.data	
							},()=>{
								
								
								 let BrachApi = this.state.brachData.map(row => {
                          
          return {value:row.bm_id,display:row.bm_name}
        });
      
		
        this.setState({
          brachData: [{value: '', display:'Select Title'}].concat(BrachApi)
        },()=>{});
								
							})
	
														
			}else{
				this.setState({brachData:[]});
			}
 
    });

}
  
  
  
  
  
  
	  
render() { 
  
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  
 
  
  return (
  

<React.Fragment>
<div className="boxheading">
				
<h2>Trial Class Report</h2>
</div>
<div className="clear"></div>

 <div className="searchmaster">


  
  <ul>
  {localStorage.getItem("AYLrole")==="1" && (
  <li><p>Branch</p>
 
 <p><FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native 	inputProps={{tabIndex: "3"}}
			value={this.state.bmid}
			onChange={this.myChangeHandler}
			name='bmid'
			
			fullwidth
			
			
			>
		
			{this.state.brachData.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl></p></li>
  )}
		  <li><p>Name/ Email/ Phone</p><p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.orname}
        inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
			
            name="orname" onChange={this.myChangeHandler}
		
          /></p></li>

 <li>
 <p>Status</p>
  <p><FormControl  className="stadrp">
  <Select
         native
		 variant="outlined" className="txtbox"
          margin="normal"
          onChange={this.myChangeHandler}
          id="oractive"
		   value={this.state.oractive}
		  name="oractive"
		inputProps={{tabIndex: "5"}}
        >
	<option value="">Select Status</option>
	<option value={4}>Schedule</option>
	<option value={5}>Not Scheduled</option>	
	<option value={6}>Completed</option>
        </Select>

		</FormControl></p>
 </li>
 
 
  <li><p>Class Type</p>
	<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined" inputProps={{tabIndex: "2"}}
		  className="txtbox"
          margin="normal"
          onChange={this.myChangeHandler}
          id="type"
		   value={this.state.classtype}
		  name="classtype"
		
        >
	
	<option value="">Select Class Type</option>
                  <option value={1}>Personal Training at Home</option>
          <option value={2}>Personal Training in studio</option>
 <option value={3}>Group</option>
 <option value={4}>Prenatal</option> 
 <option value={6}>Personal Training Online</option>

        </Select>

		</FormControl>
		</p>
	</li>
 
 <li>
 <p> From Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.invoicedate) }
className="txtbox" 
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 
 
	  <li>
 <p>To Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.invoicetodate) }
className="txtbox" 
    onChange={this.handtodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>	
		
		
		
		
		
 
 
 
 
 		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="leadmasterreport"
							filename="Trial Report"
							sheet="Trial Report"
							buttonText="EXPORT"/></p></li> 
		
		
		
		
		</ul>
		
</div>	
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.orderdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.orderdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >




<TableCell>{item.or_createdate}</TableCell>
<TableCell>{item.or_name}</TableCell>
<TableCell>{item.or_email}</TableCell>

<TableCell>{item.classtype} - {item.sb_title}</TableCell>



<TableCell>{item.or_sm_id!=="0" &&( <p>{item.startdate} & {item.sm_slotname} </p> )}</TableCell>


<TableCell> <p>{item.trialclass} </p> </TableCell>




<TableCell> <p>{item.bm_name} </p> </TableCell>




<TableCell>

<a href={'/Orderview?orid='+item.or_id+'&type=2'}>
<VisibilityIcon/></a></TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="10">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
       
        rowsPerPageOptions={[50,100,200,300,400]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}   
      />   
  </Paper>
  <div style={{"display":"none"}}>
  <Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="leadmasterreport">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.orderdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.orderdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >




<TableCell>{item.or_createdate}</TableCell>
<TableCell>{item.or_name}</TableCell>
<TableCell>{item.or_email}</TableCell>

<TableCell>{item.classtype} - {item.sb_title}</TableCell>



<TableCell>{item.or_sm_id!=="0" &&( <p>{item.startdate} & {item.sm_slotname} </p> )}</TableCell>


<TableCell> <p>{item.trialclass} </p> </TableCell>




<TableCell> <p>{item.bm_name} </p> </TableCell>





 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="10">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  
  </Paper></div>
</React.Fragment>
  );
  }
	  
	  

	   }